import LanguageSetter from './LanguageSetter';

export default LanguageSetter;
